import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import {
  AuthGuard,
  CmsConfig,
  ConfigModule,
  I18nModule,
  UrlModule
} from '@spartacus/core';
import {
  FormErrorsModule,
  GlobalMessageComponentModule,
  PasswordVisibilityToggleModule,
  SpinnerModule,
} from '@spartacus/storefront';
import { KbSecurePasswordComponent } from './kb-secure-password.component';

@NgModule({
  declarations: [KbSecurePasswordComponent],
  providers: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    UrlModule,
    I18nModule,
    FormErrorsModule,
    SpinnerModule,
    PasswordVisibilityToggleModule,
    GlobalMessageComponentModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,

    ConfigModule.withConfig({
      cmsComponents: {
        SecurePasswordFlexComponent: {
          component: KbSecurePasswordComponent,
          guards: [AuthGuard]
        },
      },
    } as CmsConfig),
  ],
})
export class KbSecurePasswordModule { }
